import { render, staticRenderFns } from "./CustomerBalanceDifferences.vue?vue&type=template&id=375a89eb"
import script from "./CustomerBalanceDifferences.vue?vue&type=script&lang=js"
export * from "./CustomerBalanceDifferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports